<template>
  <div class="tabs mr-12" :class="{
      tabs_light: !isDark,
    }">
    <div
      class="tabs-item"
      @click="changeView('services')"
      :class="{
        'tabs-item_active': 'services' === active,
      }"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.7482 5.8163C13.7482 5.8163 13.2478 2.7509 10.933 2.53199C10.9017 2.50072 10.9955 2 10.2133 2C9.43153 2 9.52535 2.50072 9.49408 2.53199C7.17957 2.7509 6.67885 5.8163 6.67885 5.8163L6.27231 6.28575C6.55376 7.44282 10.2133 7.44282 10.2133 7.44282C10.2133 7.44282 13.8733 7.44282 14.1547 6.28575L13.7482 5.8163Z"
          :stroke="getColor('services')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.1978 7.9903C8.99313 7.9903 7.85061 7.82667 6.82589 7.53467C6.77499 7.75212 6.74808 7.97757 6.74808 8.2092C6.74808 9.10592 7.15025 9.91645 7.79715 10.4961C8.06151 11.6877 9.04295 12.5728 10.2135 12.5728C11.384 12.5728 12.3654 11.6877 12.6298 10.4961C13.2771 9.91645 13.6792 9.10592 13.6792 8.2092C13.6792 7.97466 13.6516 7.7463 13.5992 7.52631C12.5669 7.82376 11.4142 7.9903 10.1978 7.9903Z"
          :stroke="getColor('services')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.5468 12.9637C14.4519 12.3383 12.5752 11.6187 12.5752 11.6187C12.5752 11.6187 11.668 12.995 10.1978 12.995C8.72765 12.995 7.82039 11.6187 7.82039 11.6187C7.82039 11.6187 5.94369 12.3383 4.84917 12.9637C3.75427 13.5895 2.94083 15.6226 3.00338 16.78C3.81682 17.9375 10.1978 18 10.1978 18C10.1978 18 16.5788 17.9375 17.3922 16.78C17.4548 15.6226 16.6417 13.5895 15.5468 12.9637Z"
          :stroke="getColor('services')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.72488 13.0264L6.85105 12.5883V14.9969H5.72488V13.0264Z"
          :stroke="getColor('services')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.7334 13.0264L13.6073 12.5883V14.9969H14.7334V13.0264Z"
          :stroke="getColor('services')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.1978 17.4681C10.1978 17.4681 13.2691 17.4379 15.4218 17.0332V16.071C15.4218 15.7372 15.1509 15.4663 14.8167 15.4663H5.64155C5.30774 15.4663 5.03683 15.7372 5.03683 16.071V17.0448C7.18589 17.4386 10.1978 17.4681 10.1978 17.4681Z"
          :stroke="getColor('services')"
          stroke-linejoin="round"
        />
      </svg>

      <div class="tabs-item__text">
        <span>{{ $t("navigation.services") }}</span>
      </div>
    </div>

    <div
      class="tabs-item"
      @click="changeView('schedule')"
      :class="{
        'tabs-item_active': 'schedule' === active,
      }"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.9499 18.9999H2.05C1.45 18.9999 1 18.5499 1 17.9499V2.05C1 1.45 1.45 1 2.05 1H17.8749C18.4749 1 18.9249 1.45 18.9249 2.05V17.8749C18.9999 18.5499 18.5499 18.9999 17.9499 18.9999Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.99997 6.99997H1V2.05C1 1.45 1.45 1 2.05 1H6.99997V6.99997Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.9999 1H6.99994V6.99997H12.9999V1Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 6.99997H13V1H17.95C18.55 1 19 1.45 19 2.05V6.99997Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.99997 6.99976H1V12.9997H6.99997V6.99976Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.9999 6.99976H6.99994V12.9997H12.9999V6.99976Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 6.99976H13V12.9997H19V6.99976Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.99997 19H2.05C1.45 19 1 18.55 1 17.95V13H6.99997V19Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.9999 13H6.99994V19H12.9999V13Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.95 19H13V13H19V17.95C19 18.55 18.55 19 17.95 19Z"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.79999 8.80005L11.2 11.2"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.2 8.80005L8.79999 11.2"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.79999 14.7998L5.19998 17.1998"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.19998 14.7998L2.79999 17.1998"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.7999 8.80005L17.1999 11.2"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.1999 8.80005L14.7999 11.2"
          :stroke="getColor('schedule')"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.6 2C7.27083 2 6.2385 3.38706 6.2385 5.41525C6.18782 5.63177 6.16095 5.85674 6.16095 6.08786C6.16095 6.98198 6.56175 7.78972 7.20672 8.36712C7.47046 9.55532 8.44866 10.4375 9.61574 10.4375C10.7824 10.4375 11.7606 9.55532 12.0244 8.36712C12.6694 7.78972 13.0705 6.98198 13.0705 6.08786C13.0705 5.85406 13.0425 5.62602 12.9907 5.4068C12.9907 2.99087 11.9603 2 9.6 2Z"
          :stroke="getColor('clients')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.2461 12.6833C14.0902 12.0229 12.1088 11.2632 12.1088 11.2632C12.1088 11.2632 11.6466 14.9291 9.59923 16.9105C7.48543 14.8957 7.08924 11.2632 7.08924 11.2632C7.08924 11.2632 5.10789 12.0229 3.95194 12.6833C2.79599 13.3436 1.93719 15.4904 2.00361 16.7124C2.86202 17.934 9.59923 18 9.59923 18C9.59923 18 16.3361 17.934 17.1945 16.7124C17.2605 15.4904 16.4021 13.3436 15.2461 12.6833Z"
          :stroke="getColor('clients')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.83951 12.4521H10.3256L10.0945 13.5417H9.07062L8.83951 12.4521Z"
          :stroke="getColor('clients')"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.3256 14.8628L9.6319 16.3819L8.83951 14.8628L9.07062 13.7733H10.0941L10.3256 14.8628Z"
          :stroke="getColor('clients')"
          stroke-linejoin="round"
        />
        <path
          d="M7.66714 2.44574C7.66714 2.44574 8.79008 5.58304 10.6063 5.55002C13.0883 5.50511 12.9827 5.05478 12.9827 5.05478"
          :stroke="getColor('clients')"
          stroke-linejoin="round"
        />
        <path
          d="M8.72385 4.39417C8.72385 4.39417 7.83241 6.01234 6.24725 5.41805"
          :stroke="getColor('clients')"
          stroke-linejoin="round"
        />
      </svg>-->

      <div class="tabs-item__text">
        <span>Arbeitskalender</span>
      </div>
    </div>

    <div
      class="tabs-item"
      @click="changeView('todo')"
      :class="{
        'tabs-item_active': 'todo' === active,
      }"
    >
      <svg
        id="Layer_1_1_"
        width="20"
        height="20"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        :fill="getColor('todo')"
      >
        <path
          d="m8 19h8c.55225 0 1-.44775 1-1v-3h-2v2h-6v-6h3v-2h-4c-.55225 0-1 .44775-1 1v8c0 .55225.44775 1 1 1z"
        />
        <path
          d="m12 13.58594-1.29297-1.29297-1.41406 1.41406 2 2c.19531.19531.45117.29297.70703.29297s.51172-.09766.70703-.29297l6-6-1.41406-1.41406z"
        />
        <path
          d="m15 30h-6v-6h3v-2h-4c-.55225 0-1 .44775-1 1v8c0 .55225.44775 1 1 1h8c.55225 0 1-.44775 1-1v-3h-2z"
        />
        <path
          d="m12 26.58594-1.29297-1.29297-1.41406 1.41406 2 2c.19531.19531.45117.29297.70703.29297s.51172-.09766.70703-.29297l6-6-1.41406-1.41406z"
        />
        <path
          d="m16 35h-8c-.55225 0-1 .44775-1 1v8c0 .55225.44775 1 1 1h8c.55225 0 1-.44775 1-1v-8c0-.55225-.44775-1-1-1zm-1 8h-6v-6h6z"
        />
        <path
          d="m16 48h-8c-.55225 0-1 .44775-1 1v8c0 .55225.44775 1 1 1h8c.55225 0 1-.44775 1-1v-8c0-.55225-.44775-1-1-1zm-1 8h-6v-6h6z"
        />
        <path
          d="m57.70703 5.29297c-.39062-.39062-1.02344-.39062-1.41406 0l-6.29297 6.29297-9.29297-9.29297c-.1875-.1875-.44189-.29297-.70703-.29297h-37c-.55225 0-1 .44775-1 1v58c0 .55225.44775 1 1 1h47c.55225 0 1-.44775 1-1v-39.58594l10.70703-10.70703c.39062-.39062.39062-1.02344 0-1.41406zm-8.70703 54.70703h-45v-56h35.58594l8 8h-6.58594v-5h-2v6c0 .55225.44775 1 1 1h7.58594l-23.29297 23.29297c-.10986.10986-.19238.24365-.2417.39062l-2 6c-.11963.35938-.02637.75586.2417 1.02344.19043.19092.44629.29297.70703.29297.10596 0 .2124-.0166.31641-.05127l6-2c.14697-.04932.28076-.13184.39062-.2417l19.29297-19.29297zm-23.56299-20.14893 1.71191 1.71191-2.56787.85596zm3.56299.73487-2.58594-2.58594 30.58594-30.58594 2.58594 2.58594z"
        />
        <path d="m45 56h2v2h-2z" />
        <path d="m41 56h2v2h-2z" />
        <path d="m37 56h2v2h-2z" />
      </svg>

      <div class="tabs-item__text">
        <span>Probleme</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        active: {
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            activeTheme: 'activeTheme',
        }),
        isDark() {
            return this.activeTheme === 'dark'
        },
    },
    methods: {
        changeView(view) {
            this.$emit('changeView', view)
        },
        getColor(tab) {
            if (tab === this.active) {
                return this.isDark ? '#000' : '#304156'
            }

            return this.isDark ? '#fff' : '#304156'
        },
    },
}
</script>
